
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import {
    OC_PLUS_SUBSCRIPTION_PAYMENT_STATUS,
    SUBSCRIPTION_PAYMENT_PAID,
} from '@marketplace/graphql/ocplus.js'
import { track } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

import BuyOcPlusCongratulations from './parts/plus/BuyOcPlusCongratulations.vue'
import BuyOcPlusIntro from './parts/plus/BuyOcPlusIntro.vue'
import BuyOcPlusPaymentMethod from './parts/plus/BuyOcPlusPaymentMethod.vue'

const STEP_INTRO = 'intro'
const STEP_PAYMENT = 'paymentMethod'
const STEP_CONGRATULATIONS = 'congratulations'

export default {
    name: 'ModalBuyOcPlus',

    components: {
        Loader,
        BuyOcPlusIntro,
        BuyOcPlusPaymentMethod,
        BuyOcPlusCongratulations,
    },

    props: {
        checkPaymentStatus: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isLoading: false,
            currentStep: STEP_INTRO,
            paymentFailed: false,
            syncPaymentStatusIndex: 0,

            // Steps config
            STEP_INTRO,
            STEP_PAYMENT,
            STEP_CONGRATULATIONS,
        }
    },

    mounted() {
        if (this.checkPaymentStatus) {
            this.currentStep = 'checkingStatus'
            this.isLoading = true
            this.syncPaymentStatus()
        }
    },

    methods: {
        syncPaymentStatus() {
            this.$apollo
                .query({
                    fetchPolicy: 'no-cache',
                    query: OC_PLUS_SUBSCRIPTION_PAYMENT_STATUS,
                })
                .then((response) => {
                    const data =
                        response.data.viewer?.account?.orderchampPlus
                            ?.paymentStatus

                    if (
                        data?.state === 'FAILED' ||
                        this.syncPaymentStatusIndex > 3
                    ) {
                        this.syncPaymentStatusIndex = 0
                        this.paymentFailed = true
                        this.currentStep = STEP_PAYMENT
                        this.$sentry.captureException('OC Plus payment failed')
                        track('OC Plus payment failed')
                        return
                    }

                    if (data?.state === 'OPEN') {
                        setTimeout(() => {
                            this.syncPaymentStatusIndex++
                            this.syncPaymentStatus()
                        }, 3000)
                        return
                    }
                    localStorage.removeItem('ocShowPlusPaymentModal')
                    EventBus.$emit('triggerSummaryRefresh')
                    this.currentStep = STEP_CONGRATULATIONS
                    track('OC Plus payment success')
                    this.$store.commit('ocplus/updateOcPlusState', true)
                })
                .finally(() => {
                    this.isLoading = false
                })
                .catch((error) => {
                    this.$sentry.captureException(error)
                })
        },

        markAsPaid() {
            if (this.$config.appEnv === 'production') {
                return
            }

            this.$apollo
                .mutate({
                    mutation: SUBSCRIPTION_PAYMENT_PAID,
                })
                .then((response) => {
                    this.isLoading = false
                    this.currentStep = STEP_CONGRATULATIONS
                    track('OC Plus payment success')
                })
                .catch((error) => {
                    this.$sentry.captureException(error)
                })
        },
    },
}
